import { mapStateToProps } from '@segurosvoluntarios_vel/commons-services';
import { AppState } from 'src/app/store/state/app.state';

import { createSelector } from '@ngrx/store';
import { Ciudad } from 'src/app/pago/models/Ciudad.model';
import { MaestrosState } from 'src/app/store/state/maestros.state';
import { Maestro } from 'src/app/pago/models/Maestro.model';
import { Departamento } from 'src/app/pago/models/Departamento.model';

const selectFeature = (appState: AppState): MaestrosState => appState.maestros;

export const selectTiposDocumento = createSelector(
  selectFeature,
  (maestrosState: MaestrosState): Maestro[] =>
    mapStateToProps(maestrosState.tiposDeDocumento)
);

export const selectCiudades = createSelector(
  selectFeature,
  (maestrosState: MaestrosState): Ciudad[] =>
    mapStateToProps(maestrosState.ciudades)
);

export const selectDepartamentos = createSelector(
  selectFeature,
  (maestrosState: MaestrosState): Departamento[] =>
    mapStateToProps(maestrosState.departamentos)
);
